import { styled } from "@linaria/react";
export const BubblesOverlayEditorStyle = /*#__PURE__*/styled('div')({
  name: "BubblesOverlayEditorStyle",
  class: "gdg-b1ygi5by",
  propsAsIs: false
});

